"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfPictureExporterFactory = void 0;
var extension_helper_1 = require("../../../../core/formats/utils/extension-helper");
var rtf_jpeg_picture_exporter_1 = require("./rtf-jpeg-picture-exporter");
var rtf_png_picture_exporter_1 = require("./rtf-png-picture-exporter");
var RtfPictureExporterFactory = (function () {
    function RtfPictureExporterFactory() {
    }
    RtfPictureExporterFactory.createRtfPictureExporter = function (rtfBuilder, run, _imageCache) {
        var base64Uri = run.size.cacheInfo.base64;
        var contentType = extension_helper_1.ExtensionHelper.getMimeTypeFromBase64Uri(base64Uri);
        var extension = extension_helper_1.ExtensionHelper.convertMimeTypeToExtension(contentType);
        if (extension == 'jpeg')
            return new rtf_jpeg_picture_exporter_1.RtfJpegPictureExporter(rtfBuilder, run, base64Uri);
        else
            return new rtf_png_picture_exporter_1.RtfPngPictureExporter(rtfBuilder, run, base64Uri);
    };
    return RtfPictureExporterFactory;
}());
exports.RtfPictureExporterFactory = RtfPictureExporterFactory;
